import {
    Collapse,
    CollapseProps,
} from '@mui/material';
import { MenuItem } from 'generated/graphql';
import { LevelTwoLinks } from './LevelTwoLinks/LevelTwoLinks';
import { LevelTwoCategory } from './LevelTwoCategory/LevelTwoCategory';
import { MegaMenuCloseButton } from './MegaMenuCloseButton';

type DesktopWordpressMenuLevelTwoProps = {
    activeIndex: number | false;
    listItemIndex: number;
    listItem: MenuItem;
    closeMenu: () => void;
};

export function DesktopWordpressMenuLevelTwo(props: DesktopWordpressMenuLevelTwoProps) {
    const { activeIndex, listItemIndex, listItem, closeMenu } = props;
    const isFocused = activeIndex === listItemIndex;
    const isCategory = listItemIndex === 0;

    const collapseProps: CollapseProps & { key: any } = {
        in: isFocused,
        key: listItemIndex,
        sx: {
            justifyContent: 'center',
            flexGrow: 1,
            position: 'relative',
        },
    };

    return (
        <Collapse {...collapseProps}>
            {isCategory
                ? (
                    <LevelTwoCategory
                        isFocused={isFocused}
                        category={listItem}
                    />
                )
                : (
                    <LevelTwoLinks
                        listItem={listItem}
                        isFocused={isFocused}
                    />
                )}
            <MegaMenuCloseButton closeMenu={closeMenu} />
        </Collapse>
    );
}
